export const NG_APP_SELECTOR_ID = 'ng-app';

export const NG_APP_MODULE_NAME = 'hjApp';
